import { createSelector } from '@reduxjs/toolkit';

const documentTypeProjections = {};

documentTypeProjections.attachmentAvailableDocumentTypesOptions = (
    attachment,
    uploadOnlyOnceDocumentTypesCodes,
    questionWithDocumentTypesCode,
) =>
    createSelector(
        state => state.documentType.documentType.byId,
        state => state.question.question.byId[questionWithDocumentTypesCode],
        (documentTypesById, question) => {
            const questionDocumentTypesById =
                question && question.documentTypes
                    ? question.documentTypes.reduce(
                          (acc, curr) => ({
                              ...acc,
                              [curr.id]: curr,
                          }),
                          {},
                      )
                    : {};
            const mergedDocumentTypesOptions = {
                ...documentTypesById,
                ...questionDocumentTypesById,
            };
            const documentTypesOptionsList = Object.entries(
                mergedDocumentTypesOptions,
            ).map(([key, item]) => ({
                value: item.code,
                label: item.name,
                item: item,
            }));

            if (!attachment) {
                return documentTypesOptionsList;
            }

            return documentTypesOptionsList.filter(
                option =>
                    uploadOnlyOnceDocumentTypesCodes.includes(
                        option.item.code,
                    ) === false ||
                    (uploadOnlyOnceDocumentTypesCodes.includes(
                        option.item.code,
                    ) === true &&
                        attachment.documentTypes &&
                        attachment.documentTypes.find(
                            type => type.item.code === option.item.code,
                        )),
            );
        },
    );

export default documentTypeProjections;
